module.exports = __webpack_public_path__ + "img/locataire.cac5184b.png";